import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'

import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import LoginPage from './pages/auth/LoginPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import MatchesPage from './pages/matches/MatchesPage'
import InterestsPage from './pages/interests/InterestsPage'
import ShortlistPage from './pages/shortlist/ShortlistPage'
import ChatPage from './pages/chat/ChatPage'
import ConversationPage from './pages/chat/ConversationPage'
import SubscriptionPage from './pages/subscription/SubscriptionPage'
import ProfilePage from './pages/profile/ProfilePage'
import EditProfilePage from './pages/profile/EditProfilePage'
import NotificationsPage from './pages/notifications/NotificationsPage'
import ViewersPage from './pages/profile/ViewersPage'
import SafetyCenterPage from './pages/SafetyCenterPage'
import AdminPage from './pages/admin/AdminPage'
import { PrivacyPolicyPage, TermsPage, DeleteAccountPage, ChildSafetyPage } from './pages/legal/LegalPages'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/child-safety" element={<ChildSafetyPage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/matches" element={<MatchesPage />} />
            <Route path="/interests" element={<InterestsPage />} />
            <Route path="/shortlist" element={<ShortlistPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/chat/:conversationId" element={<ConversationPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profile/edit" element={<EditProfilePage />} />
            <Route path="/profile/viewers" element={<ViewersPage />} />
            <Route path="/safety" element={<SafetyCenterPage />} />
            <Route path="/profile/:id" element={<ProfilePage />} />
            <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
    </QueryClientProvider>
  )
}

export default App
